import React, {useRef} from "react";
import {
    Button,
    ButtonGroup,
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Glyphicon,
    Row,
} from "react-bootstrap";
import Select from "react-select";

const displaySizeOptions = [
    { value: 0, label: 'На всю ширину' },
    { value: 1, label: 'Обычный' },
    { value: 2, label: 'Двойной' },
    { value: 3, label: 'Тройной' },
    { value: 4, label: 'Четвертной' },
];

const partnersDisplayOptions = [
    { value: '', label: 'Вертикально' },
    { value: 'horizontal', label: 'Горизонтально' },
];

export default ({ getProperty, setProperty, saveProperty, savePropertyFile, isSaving }) => {
    
    const backgroundImageRef = useRef(null);
    const posterRef = useRef(null);

    return <>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <Checkbox
                        checked={getProperty('enabled')}
                        onChange={(e) => saveProperty('enabled', e.target.checked)}
                        disabled={isSaving}
                    >Активен</Checkbox>
                    <Checkbox
                        checked={getProperty('visible')}
                        onChange={(e) => saveProperty('visible', e.target.checked)}
                        disabled={isSaving}
                    >Показывать в списке</Checkbox>
                    <Checkbox
                        checked={getProperty('correctAnswerVisible')}
                        onChange={(e) => saveProperty('correctAnswerVisible', e.target.checked)}
                        disabled={isSaving}
                    >Показывать правильный ответ</Checkbox>
                    <Checkbox
                        checked={getProperty('showPointsQuantity')}
                        onChange={(e) => saveProperty('showPointsQuantity', e.target.checked)}
                        disabled={isSaving}
                    >Показывать максимальное количество баллов</Checkbox>
                </Col>
                <Col xs={6}>
                    <ControlLabel>Размер блока</ControlLabel>
                    <Select
                        value={displaySizeOptions.find(({ value }) => value === getProperty('displaySize'))}
                        onChange={({ value }) => saveProperty('displaySize', value)}
                        options={displaySizeOptions}
                        isDisabled={isSaving}
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Название [Ru]</ControlLabel>
                    <FormControl
                        type="text"
                        value={getProperty('titleRu')}
                        onChange={(e) => setProperty('titleRu', e.target.value)}
                        onBlur={() => saveProperty('titleRu', getProperty('titleRu'))}
                        disabled={isSaving}
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Название [En]</ControlLabel>
                    <FormControl
                        type="text"
                        value={getProperty('titleEn')}
                        onChange={(e) => setProperty('titleEn', e.target.value)}
                        onBlur={() => saveProperty('titleEn', getProperty('titleEn'))}
                        disabled={isSaving}
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Описание [Ru]</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        value={getProperty('descriptionRu')}
                        onChange={(e) => setProperty('descriptionRu', e.target.value)}
                        onBlur={() => saveProperty('descriptionRu', getProperty('descriptionRu'))}
                        disabled={isSaving}
                        rows={5}
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Описание [En]</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        value={getProperty('descriptionEn')}
                        onChange={(e) => setProperty('descriptionEn', e.target.value)}
                        onBlur={() => saveProperty('descriptionEn', getProperty('descriptionEn'))}
                        disabled={isSaving}
                        rows={5}
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={6}>
                    <ControlLabel>Название кнопки [Ru]</ControlLabel>
                    <FormControl
                        type="text"
                        value={getProperty('buttonTextRu')}
                        onChange={(e) => setProperty('buttonTextRu', e.target.value)}
                        onBlur={() => saveProperty('buttonTextRu', getProperty('buttonTextRu'))}
                        placeholder="Участвовать"
                        disabled={isSaving}
                    />
                </Col>
                <Col xs={6}>
                    <ControlLabel>Название кнопки [En]</ControlLabel>
                    <FormControl
                        type="text"
                        value={getProperty('buttonTextEn')}
                        onChange={(e) => setProperty('buttonTextEn', e.target.value)}
                        onBlur={() => saveProperty('buttonTextEn', getProperty('buttonTextEn'))}
                        disabled={isSaving}
                        placeholder="Join"
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={3}>
                    <ControlLabel>Цвет фона</ControlLabel>
                    <FormControl
                        type="color"
                        value={'#' + getProperty('backgroundColor')}
                        onChange={(e) => setProperty('backgroundColor', e.target.value.replace('#', ''))}
                        onBlur={() => saveProperty('backgroundColor', getProperty('backgroundColor'))}
                        disabled={isSaving}
                    />
                </Col>
                <Col xs={3}>
                    <ControlLabel>Фоновая картинка</ControlLabel>
                    <div>
                        <ButtonGroup>
                            <Button bsSize="small" onClick={() => backgroundImageRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                            {getProperty('backgroundImageUrl') && <Button bsSize="small" href={getProperty('backgroundImageUrl')} target="_blank"><Glyphicon glyph="picture" /></Button>}
                            {getProperty('backgroundImageUrl') && <Button bsSize="small" onClick={() => saveProperty('backgroundImage', 'delete')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                        </ButtonGroup>
                    </div>
                    <FormControl
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => savePropertyFile('backgroundImage', e.target.files[0] || null)}
                        inputRef={(ref) => backgroundImageRef.current = ref}
                    />
                </Col>
                <Col xs={3}>
                    <ControlLabel>Постер</ControlLabel>
                    <div>
                        <ButtonGroup>
                            <Button bsSize="small" onClick={() => posterRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                            {getProperty('posterUrl') && <Button bsSize="small" href={getProperty('posterUrl')} target="_blank"><Glyphicon glyph="picture" /></Button>}
                            {getProperty('posterUrl') && <Button bsSize="small" onClick={() => saveProperty('poster', 'delete')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                        </ButtonGroup>
                    </div>
                    <FormControl
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(e) => savePropertyFile('poster', e.target.files[0] || null)}
                        inputRef={(ref) => posterRef.current = ref}
                    />
                </Col>
                <Col xs={3}>
                    <ControlLabel>Расположение партнёров</ControlLabel>
                    <Select
                        options={partnersDisplayOptions}
                        value={partnersDisplayOptions.find(({ value }) => value === getProperty('partnersDisplay'))}
                        onChange={({ value }) => saveProperty('partnersDisplay', value)}
                    />
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <Row>
                <Col xs={3}>
                    <ControlLabel>Цвет текста</ControlLabel>
                    <FormControl
                        type="color"
                        value={'#' + (getProperty('textColor') || 'ffffff')}
                        onChange={(e) => setProperty('textColor', e.target.value.replace('#', ''))}
                        onBlur={() => saveProperty('textColor', getProperty('textColor'))}
                        disabled={isSaving}
                    />
                </Col>
                <Col xs={3}>
                    <ControlLabel>Цвет кнопки</ControlLabel>
                    <FormControl
                        type="color"
                        value={'#' + (getProperty('buttonColor') || '999999')}
                        onChange={(e) => setProperty('buttonColor', e.target.value.replace('#', ''))}
                        onBlur={() => saveProperty('buttonColor', getProperty('buttonColor'))}
                        disabled={isSaving}
                    />
                </Col>
                {/* <Col xs={3}>
                    <Checkbox
                        checked={getProperty('buttonAccentColor')}
                        onChange={(e) => saveProperty('buttonAccentColor', e.target.checked)}
                        disabled={isSaving}
                    >Акцентный цвет кнопки</Checkbox>
                </Col> */}
            </Row>
        </FormGroup>
    </>
}